const validateName = (name) => {
  const trimmedName = name.trim();

  if (!trimmedName.length) {
    return {
      isValid: false,
      message: 'This field is required',
      translationKey: 'this_field_is_required',
    };
  }
  if (trimmedName.length < 3) {
    return {
      isValid: false,
      message: 'Should contain minimum 3 letters',
      translationKey: 'should_contain_minimum_3_letters',
    };
  }
  if (trimmedName.length > 20) {
    return {
      isValid: false,
      message: 'Maximum character limit is exceeded',
      translationKey: 'max_char_limit_is_exceeded',
    };
  }
  if (!/^[A-Za-zԱ-Ֆա-ֆև]+$/.test(trimmedName)) {
    return {
      isValid: false,
      message: `Only Latin/Armenian letters are accepted`,
      translationKey: 'only_Latin_Armenian_letters_accepted',
    };
  }

  return { isValid: true, message: '', translationKey: '' };
};

const validatePhone = (number) => {
  const trimmedNumber = number.trim();

  if (!trimmedNumber.length) {
    return {
      isValid: false,
      message: 'This field is required',
      translationKey: 'this_field_is_required',
    };
  }
  if (trimmedNumber.length !== 11) {
    return {
      isValid: false,
      message: 'Wrong number format',
      translationKey: 'wrong_number_format',
    };
  }
  if (!/^[0-9-]+$/.test(trimmedNumber)) {
    return {
      isValid: false,
      message: 'Only digits are accepted',
      translationKey: '"only_digits_are_accepted"',
    };
  }

  return { isValid: true, message: '', translationKey: '' };
};

const validatePassword = (password) => {
  const trimmedPassword = password.trim();

  if (!trimmedPassword.length) {
    return {
      isValid: false,
      message: 'This field is required',
      translationKey: 'this_field_is_required',
    };
  }
  if (/[^\u0020-\u007E]/.test(trimmedPassword)) {
    return {
      isValid: false,
      message: 'Only Latin characters are allowed',
      translationKey: 'only_Latin_characters_allowed',
    };
  }
  if (trimmedPassword.length < 6) {
    return {
      isValid: false,
      message: 'Password must have at least 6 characters',
      translationKey: 'password_must_have_at_least_6_characters',
    };
  }
  if (!/\d/.test(trimmedPassword)) {
    return {
      isValid: false,
      message: 'Password must contain digits',
      translationKey: 'password_must_contain_digits',
    };
  }
  if (!/[A-Z]/.test(trimmedPassword)) {
    return {
      isValid: false,
      message: 'Password must contain uppercase letters',
      translationKey: 'password_must_contain_uppercase_letters',
    };
  }
  if (!/[a-z]/.test(trimmedPassword)) {
    return {
      isValid: false,
      message: 'Password must contain lowercase letters',
      translationKey: 'password_must_contain_lowercase_letters',
    };
  }
  if (/\s/.test(trimmedPassword)) {
    return {
      isValid: false,
      message: 'Password must not contain spaces',
      translationKey: 'password_must_not_contain_spaces',
    };
  }

  return { isValid: true, message: '', translationKey: '' };
};

const validateConfirmPassword = (password, confirmation) => {
  if (password !== confirmation) {
    return {
      isValid: false,
      message: 'Passwords are not the same',
      translationKey: 'passwords_are_not_the_same',
    };
  }

  return { isValid: true, message: '', translationKey: '' };
};

export function validate(fieldName, value, password) {
  switch (fieldName) {
    case 'firstName':
      return validateName(value);
    case 'lastName':
      return validateName(value);
    case 'phone':
      return validatePhone(value);
    case 'password':
      return validatePassword(value);
    case 'confirmPassword':
      return validateConfirmPassword(value, password);

    default:
      return { isValid: false, message: 'Something is wrong' };
  }
}
